import Icon from 'icons/Icon';
import React, { Component } from 'react';
import ComponentName from '../constant/ComponentName';

class RecordNotFound extends Component<Props> {
  render() {
    const { itemId, component } = this.props;
    return (
      <div className={'flex flex-col w-full h-full bg-white items-center justify-center px-10 py-10'}>
        <p className={'text-3xl text-primary'}>
          We can not find {itemId} in {component}s{' '}
        </p>
        <a href={'/master/' + component.toLowerCase()} className={'text-3xl text-primary'}>
          Come back Homepage! <Icon icon={''} size={20}></Icon>
        </a>
      </div>
    );
  }
}
interface Props {
  itemId: string;
  component: ComponentName;
}

export default RecordNotFound;
